import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function Welcome() {
  const jsonFile = useSelector((state: any) => state.style);

  return (
    <div className="classCenter " style={{ marginTop: "5vh" }}>
      <img
        style={{ width: "70%", margin: "auto", marginTop: "5vh" }}
        src="images/welcome.png"
      />
      <br />
      <br />
      <div>
        <b
          style={{
            textAlign: "center",
            fontSize: "25px",
            color: "#00253D",
            marginTop: "5vh",
            width: "50%",
          }}
        >
          به سامانه مدیریت{" "}
          <span style={{ color: jsonFile?.mainColor }}>
            {jsonFile?.companyName}
          </span>{" "}
          خوش آمدید.
        </b>
      </div>
    </div>
  );
}
